import api from '@/services/api'

export default {
  getAll: {
    request: ({ params }) => api.get('/items', params)
  }
}
